import { View } from 'react-native'

import { Spinner } from '@/components/icon'
import { Stack } from '@/components/layout'
import NavigationBar from '@/components/NavigationBar'

function LoadingScreen({ header }: { header?: React.ReactElement }) {
  return (
    <>
      <Stack.Screen
        options={{
          header: () => header || <NavigationBar />
        }}
      />
      <View className={'flex-1 items-center justify-center bg-background-secondary'}>
        <View className={'animate-spin'}>
          <Spinner className={'size-6 text-primary'} />
        </View>
      </View>
    </>
  )
}
export default LoadingScreen
